module.exports = __webpack_public_path__ + "img/thumb-009-08.a41b0d75.png";